//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head () {
    return {
      title:
        'Manchester Pest Control | About Manchester Pest Control',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Learn more about Manchester Pest Controls history, our services and our team.'
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'Manchester Pest Control | About Manchester Pest Control'
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: 'Learn more about Manchester Pest Controls history, our services and our team.'
        }
      ]
    }
  }
}
